export const PersonFormActions = ({ children }: React.PropsWithChildren) => (
  <div className="d-flex justify-content-end align-items-center gap-2">
    {children}
  </div>
);
